var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"title":_vm.$t('pharmacy_new.content_title')}},[_c('VPharmacyCreateForm',{on:{"pharmacy-created":_vm.onPharmacyCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }